module.exports = __webpack_public_path__ + "media/components/weather-icon/static/nightclear-884a4b7661c6df6a45ddba665106c080.webp";